import Datepicker from 'vuejs-datepicker';
import lang from "@/views/modules/WorkPackages/language/en";


import Editor from '@tinymce/tinymce-vue';

export default {
    name: "new-workpackages",
 
    components: {
        Datepicker,
        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            formData:{
                workpackage_name:'',
                workpackage_description:'',
                workpackage_date:'',
            },
            dataList:[],
            lang:[],
            dateFormat:'',
            allFiles:[],
            file_content: null,
            fileUpload: false,
            fileName: [],
            disabled:false,
            processing:false,
            error_message:{
            err_name:'',
            err_desc:'',
            err_date:'',
            err_file:'',
            }
        }
    },
    mounted() {
        this.getOpportunity();
        this.lang = lang;
        this.formData = {
            parent_type:'opportunitys',
            workpackage_name:'',
            workpackage_description:'',
            workpackage_date:'',
            status:'Active',
        }
    },
    methods: {
        SaveWorkPackage(){
            const self = this;
           //console.log(self.formData.workpackage_name);
          /*  if(self.formData.workpackage_name == ''){
                self.error_message.err_name = "Please Enter Workpackage Name";
            }else{
                self.error_message.err_name = "";
            }
            if(self.formData.workpackage_description == ''){
                self.error_message.err_desc = "Please Enter Workpackage Description";
            }else{
                self.error_message.err_desc = "";
            }
            if(self.formData.workpackage_date == ''){
                self.error_message.err_date = "Please Enter Workpackage Date";
            }else{
                self.error_message.err_date = "";
            }
            if(self.allFiles.length == 0){
                self.error_message.err_file = "Please Select Atleast One File";
            }else{
                self.error_message.err_file = "";
            }*/
            //if(self.error_message.err_name == '' && self.error_message.err_desc == '' && self.error_message.err_date == '' && self.error_message.err_file == ''){
               
                self.disabled = true;
                self.processing = true;
                let formData = new FormData();                
                formData.append('file', self.allFiles);  // Add your form data
               // formData.append('formData', self.formData);  // Add your form data

               self.formData.filelist = self.allFiles;

                axios.post('api/modules/workpackages', self.formData, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                }).then(function(res){
                self.disabled = false;
                self.processing = false;
                if(res.data.message !=''){
                    self.$router.push(`/modules/workpackages`);
                }
                 }).catch(error => {
                    self.disabled = false;
                    self.processing = false;
                    self.loading = false;
                    let allerror = document.getElementsByClassName('error');
                    for(let i = 0; i < allerror.length; i++)
                    {
                        allerror[i].innerHTML = '';
                    }
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                    Object.keys(err_msg2 || {}).forEach((key) => {
                        let errorval = err_msg2[key];
                      
                        let error_el = document.getElementById(key+"_error");
                            error_el.innerHTML = errorval
                    });
                    localStorage.removeItem('Errors');
                });
           // }
        },
        customFormatter(date) {
            return moment(date).format('DD/MM/yyyy');
        },
        getOpportunity(){
            const self = this;
             window.currentAction = 'list';
                axios.get('api/modules/getActiveOpportunity',{
                params:{
                    'Status':'Active'
                }
            }).then(function(response){
                self.dataList = response.data;
            }).catch(function () {
                self.loading = false;
            });
        },
        changeFile(e) {
            let filelist = e.target.files;
            for(let i = 0; i < filelist.length; i++){
                let image = e.target.files[i];
                const MAX_FILE_NAME_LENGTH = 40;

                if (image.name.length > MAX_FILE_NAME_LENGTH) {
                    alert(`File name cannot exceed ${MAX_FILE_NAME_LENGTH} characters.`);
                    e.target.value = '';
                    return;
                }
                let fileArr = [];
                let file_type_arr = e.target.files[i].type.split("/");
                this.fileName = file_type_arr;
                this.showFileName = image.name;
                // Get the file size
                let fileSize = image.size; // in bytes

                let setSize = window.app.max_file_size;
                let definedSize = 2097152;
                if(setSize[1] == 'M')
                {
                    definedSize = ((parseInt(setSize.slice(0,-1)) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(setSize[1] == 'G')
                {
                    definedSize = (((parseInt(setSize.slice(0,-1)) * 1024) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(fileSize <= definedSize)
                {
                let reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                //  this.file_content = e.target.result;
                    this.fileUpload = true;
                    fileArr.push(e.target.result, this.fileUpload, file_type_arr[1], image.name);
                    this.allFiles.push(fileArr);
                    }; 
                }else{
                    this.file_error = "The file size exceeds the maximum limit. Allowed file max size is "+ setSize;
                }
            }
        },
        
    }
}